import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MmTranslateService } from 'mm-web-core/i18n';
import { mmTableConstants } from '../mm-table-constants';
import { map, switchMap } from 'rxjs/operators';
import { iif } from 'rxjs';

@Component({
  templateUrl: './total-template.component.html',
  styleUrls: ['./total-template.component.scss']
})
export class TotalTemplateComponent implements OnInit {

  constructor(private translateService: MmTranslateService) { }

  ngOnInit(): void {
  }

  @ViewChild('template', { static: true })
  template: TemplateRef<any>;

  isPlural(total: number, path: string): string {
    return total > 1 ? `${path}s` : path;
  }

  totalLabel(total: number) {
    return this.translate("Total").pipe(
      map(txt => `${txt} ${total}`),
      switchMap(txt => iif(() => total > 1,
        this.translate("Items").pipe(map(p => `${txt} ${p}`)),
        this.translate("Item").pipe(map(p => `${txt} ${p}`))
      ))
    )
  }

  translate(key: string) {
    return this.translateService.get(`${mmTableConstants.translationGroup}.${key}`)
  }

}
